<div class="col">
	<div class="row row-cols-2 gap-4 justify-content-center p-2">
		<div class="col col-auto col-lg-2 ">
			<div class="row">
				<img class="bg-transparent img-fluid p-0" [src]="'grouping-test-img.jpg'" />
			</div>
		</div>

		<div class="col col-auto col-lg-9">
			<div class="row justify-content-center m-2 border-bottom">
				<p class="text-center article-text display-4 m-0">Who We Are</p>
			</div>
			<div class="row align-middle m-2">
				<p class="text-center m-0 article-text">Wyvern Weaponry is an Arkansas Small Business dedicated to the training of responsibly armed Americans. We specialize in Concealed Carry Certification for Arkansas Residents, Basic Handgun Safety Courses, and Professional Range Safety Supervision.</p>
			</div>
		</div>
	</div>

	<div class="row row-cols-lg-2 gap-4 justify-content-center p-2">
		<div class="col col-auto col-lg-9">
			<div class="row justify-content-center m-2 border-bottom">
				<p class="text-center article-text display-4 m-0">Who We Serve</p>
			</div>
			<div class="row justify-content-center">
				<ul>
					<li>Church Security Teams</li>
					<li>Arkansas CHCL Holders</li>
					<li>New Firearm Owners</li>
					<li>Private Ranges</li>
				</ul>
			</div>
		</div>
		<div class="col col-auto col-lg-2">
			<div class="row">
				<img class="bg-transparent img-fluid p-0" [src]="'wyvern-vertical.svg'" />
			</div>
		</div>
	</div>
</div>

